import React from 'react';
import range from 'lodash.range';
import clsx from 'clsx';

import styles from './GuestsIndicator.module.css';

interface Props {
  numGuests: number;
  positioningClassName?: string;
}

export class GuestsIndicator extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    const { numGuests, positioningClassName = '' } = this.props;

    return (
      <div className={clsx(styles.guestsIndicator, positioningClassName)}>
        {numGuests < 4
          ? renderGuests(numGuests)
          : renderGuestsWithText(numGuests)}
      </div>
    );
  }
}

function renderGuestsWithText(guestCount: number): React.ReactNode {
  return (
    <>
      <span className={styles.text}>{guestCount}</span>
      {renderGuests(1)}
    </>
  );
}

function renderGuests(guestCount: number): React.ReactNode {
  const circles = range(guestCount).map((idx) => (
    <circle
      key={idx}
      cx={`${idx * 10 + 8}`}
      style={{ strokeWidth: '2' }}
      cy="6"
      r="3"
      stroke="#B3B3B3"
    />
  ));
  const paths = range(guestCount).map((idx) => (
    <path
      key={idx}
      stroke="#B3B3B3"
      style={{ strokeWidth: '2' }}
      d={`M${idx * 10 + 3} 14c0-3 2-5 5-5s5 2 5 5`}
    />
  ));
  const width = guestCount * 10 + 6;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height="16"
      viewBox={`0 0 ${width} 16`}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        {circles}
        {paths}
      </g>
    </svg>
  );
}
